// The strings coming back look like
//   2025-04-10 19:33:02.475807
// And we want them to look like
//   2025-04-10T19:33:02.475807Z
// before we parse them
export function parsePostgresDate(timestamp: string): Date {
	// Handle both PostgreSQL format ("2025-08-04 21:25:09.955") and ISO format ("2025-08-04T21:25:09.955Z")
	if (timestamp.includes('T')) {
		// Already in ISO format
		return new Date(timestamp);
	} else {
		// PostgreSQL format - convert to ISO
		return new Date(timestamp.replace(' ', 'T') + 'Z');
	}
}

// Helper function to process frame entries and convert date fields
export function processFrameEntries(entries: any[]): any[] {
	return entries.map((entry) => {
		if (entry.kind === 'comment') {
			return {
				...entry,
				createdAt: parsePostgresDate(entry.createdAt),
				deletedAt: entry.deletedAt ? parsePostgresDate(entry.deletedAt) : null,
			};
		}
		return entry;
	});
}

// A Fake UUID that changes every 20 minutes
export function timeAsUuid(intervalMinutes = 20) {
	const timeStep = Math.floor(Date.now() / 1000 / (intervalMinutes * 60));
	const hex = timeStep.toString(16).padStart(32, '0');
	// Format like UUID: 8-4-4-4-12
	return [
		hex.slice(0, 8),
		hex.slice(8, 12),
		hex.slice(12, 16),
		hex.slice(16, 20),
		hex.slice(20),
	].join('-');
}
